export const AGENTS = [
  "Brimstone",
  "Phoenix",
  "Sage",
  "Sova",
  "Viper",
  "Cypher",
  "Reyna",
  "Killjoy",
  "Breach",
  "Omen",
  "Jett",
  "Raze",
  "Skye",
  "Yoru",
  "Astra",
  "KAY/O",
  "Chamber",
  "Neon",
  "Fade",
  "Harbor",
  "Gekko",
  "Deadlock",
  "Iso",
  "Clove",
  "Vyse",
  "Tejo",
  "Waylay",
];

export const TIER_TITLES = [
  "My Top 3 Agents",
  "Very Good Comfort Characters",
  "Can comfortably fill",
  "Willing to learn",
  "Ranked only",
  "Probably not a good Idea",
];


export const TIER_DEFINITIONS = [
 'Your three strongest agents: confident and eager to play them in team matches.',
 'Strong comfort picks you can reliably play in coordinated team matches.',
 'You know the role and utility well enough to fill when the team needs it.',
 'You want to practice this agent, but need preparation before team matches.',
 'Comfortable in ranked, but not yet confident with this agent in coordinated team play.',
 'Not currently comfortable or willing to play this agent in team matches.'
];
export function cleanTiers(input = {}) {
 const seen = new Set();
 return Object.fromEntries(TIER_TITLES.map((tier, i) => [tier, (Array.isArray(input[tier]) ? input[tier] : []).filter(agent => {
  if (!AGENTS.includes(agent) || seen.has(agent)) return false;
  seen.add(agent); return true;
 }).slice(0, i === 0 ? 3 : AGENTS.length)]));
}
export function compositionKey(agents) { return [...agents].sort().join('|'); }
export function validateComposition(agents) {
 if (!Array.isArray(agents) || agents.length !== 5 || new Set(agents).size !== 5 || agents.some(agent => !AGENTS.includes(agent))) throw new Error('Choose five different agents.');
 return [...agents].sort();
}
